import { ResumeFlowContext } from '@chargeafter/payment-types';

import { logger } from '../../logger';
import { paymentsPresent } from '../present/payments/paymentsPresent';
import { printInitError } from '../printInitError/printInitError';
import { store } from '../store';

const filename = 'resumeFlow';

export const resumeFlow = async (
  sessionToken: string,
  context: ResumeFlowContext
) => {
  if (!store.isInitialized) return printInitError('resumeFlow', filename);

  logger.linkId = store.config?.linkId;

  logger.log(`about to present ResumeFlow`, {
    function: 'resumeFlow',
    filename,
    context,
  });

  return paymentsPresent('resume', {
    ...context,
    sessionToken,
  });
};
